import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import { BasicSelect } from 'vue-search-select'
import utils from '../../../utils/validateScanner'

export default {
  name: 'ManualDockOut',

  mixins: [utils],

  components: {
    VueElementLoading,
    BasicSelect,
  },

  data() {
    return {
      hubId: '',
      hubName: '',
      createdBy: '',
      hasManualDockOutAccess: false,
      roleConfigLoaded: false,
      isLoading: false,
      isLoadingSearch: false,
      searchValue: '',
      selectedSearchType: {
        text: '',
        value: '',
      },
      searchTypeOptions: [
        {
          text: 'Dock ID',
          value: 'dock_id',
        },
        {
          text: 'Vehicle Number',
          value: 'vehicle_number',
        },
        {
          text: 'Trip ID',
          value: 'trip_id',
        },
      ],
      reasonOptions: [],
      sessionData: [],
      dockOutModalShow: false,
      dockOutVehicle: '',
      dockOutDockId: '',
      dockOutReason: '',
      dockOutSessionId: null,
      dockOutIndex: null,
    }
  },

  computed: {
    searchPlaceholder() {
      if (!this.selectedSearchType.value) {
        return 'Select search type first'
      }

      if (this.selectedSearchType.value === 'dock_id') {
        return 'Enter Dock ID (leave blank to show all active sessions)'
      }

      if (this.selectedSearchType.value === 'vehicle_number') {
        return 'Enter Vehicle Number'
      }

      if (this.selectedSearchType.value === 'trip_id') {
        return 'Enter Trip ID'
      }

      return 'Enter search value'
    },

    isSearchValueRequired() {
      return (
        this.selectedSearchType.value &&
        this.selectedSearchType.value !== 'dock_id'
      )
    },

    isSearchDisabled() {
      if (!this.selectedSearchType.value) {
        return true
      }

      if (this.selectedSearchType.value === 'dock_id') {
        return false
      }

      return !this.searchValue
    },
  },

  watch: {
    roleconfig: {
      immediate: true,

      handler: function (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.hasManualDockOutAccess = this.validateUserRole(
            newVal.manual_dockout_role
          )

          this.roleConfigLoaded = true

          if (this.hasManualDockOutAccess) {
            this.getDockOutReasons()
          }
        }
      },
    },
  },

  filters: {
    moment1: function (date) {
      if (!date) {
        return '--'
      }

      const d = new Date(date)

      return d
        .toLocaleString('en-GB', {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
        .replace(
          /(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/,
          '$1-$2-$3 $4:$5:$6'
        )
    },
  },

  mounted() {
    const userdetailEncrypt =
      window.localStorage.getItem('userdetail')

    const bytes = CryptoJS.AES.decrypt(
      userdetailEncrypt.toString(),
      'Key'
    )

    const plaintext = bytes.toString(
      CryptoJS.enc.Utf8
    )

    const userdetail = JSON.parse(plaintext)

    this.createdBy = userdetail[0].email
    this.hubId = userdetail[0].HubId[0]

    this.getHubName(this.hubId)
    this.hubForManualRestriction()
  },

  methods: {
    getHubName(hubid) {
      const input = {
        hubids: [hubid],
      }

      axios
        .post(
          `${apiUrl.api_url_hubops}expose/hubservicecenter/hubarray/get`,
          input,
          {
            headers: {
              authorization: 'authkey xB84JJ89Hd25',
            },
          }
        )
        .then(result => {
          if (
            result.data.ResultCode === 100 &&
            result.data.ResponseData &&
            result.data.ResponseData.length > 0
          ) {
            this.hubName =
              result.data.ResponseData[0].HubName
          }
        })
        .catch(error => {
          console.error(error)
        })
    },

    onSearchTypeSelect(option) {
      this.selectedSearchType = option
    },

    searchSessions() {
      if (!this.hasManualDockOutAccess) {
        this.$alertify.error(
          'You do not have access to Manual Dock-Out.'
        )
        return
      }

      if (!this.selectedSearchType.value) {
        this.$alertify.error(
          'Please select a search type.'
        )
        return
      }

      const requiresValue =
        this.selectedSearchType.value !== 'dock_id'

      if (requiresValue && !this.searchValue) {
        this.$alertify.error(
          'Please enter a search value.'
        )
        return
      }

      this.isLoadingSearch = true
      this.sessionData = []

      const url =
        `${apiUrl.api_url_hubops}dockmaster/searchSessions` +
        `?hubId=${this.hubId}` +
        `&searchType=${this.selectedSearchType.value}` +
        `&searchValue=${encodeURIComponent(this.searchValue)}`

      axios({
        method: 'GET',
        url: url,
        headers: {
          authorization: 'authkey xB84JJ89Hd25',
        },
      })
        .then(result => {
          if (result.data.ResultCode === 100) {
            const responseData = Array.isArray(
              result.data.ResponseData
            )
              ? result.data.ResponseData
              : []

            this.sessionData = responseData.map(
              function (item) {
                return Object.assign({}, item, {
                  selectedReason: {
                    text: '',
                    value: '',
                  },
                })
              }
            )

            if (this.sessionData.length === 0) {
              this.$alertify.error(
                'No active sessions found.'
              )
            }
          } else {
            this.$alertify.error(
              result.data.ReturnMessage
            )
          }

          this.isLoadingSearch = false
        })
        .catch(error => {
          this.isLoadingSearch = false

          console.error(error)

          this.$alertify.error(
            'Error fetching sessions.'
          )
        })
    },

    resetSearch() {
      this.selectedSearchType = {
        text: '',
        value: '',
      }

      this.searchValue = ''
      this.sessionData = []
    },

    confirmDockOut(data, index) {
      if (
        !data.selectedReason ||
        !data.selectedReason.value
      ) {
        this.$alertify.error(
          'Please select a reason before dock out.'
        )
        return
      }

      this.dockOutSessionId = data.session_id
      this.dockOutVehicle = data.vehicle_number
      this.dockOutDockId = data.dock_id
      this.dockOutReason =
        data.selectedReason.text
      this.dockOutIndex = index
      this.dockOutModalShow = true
    },

    executeDockOut() {
      this.dockOutModalShow = false
      this.isLoadingSearch = true

      const payload = {
        session_id: this.dockOutSessionId,
        vehicle_number: this.dockOutVehicle,
        hub_id: this.hubId,
        reason: this.dockOutReason,
        dock_out_by: this.createdBy,
        is_manual: true,
        status_marked_from: 'WEB',
      }

      axios({
        method: 'POST',
        url: `${apiUrl.api_url_hubops}dockmaster/dockOut`,
        data: payload,
        headers: {
          authorization: 'authkey xB84JJ89Hd25',
        },
      })
        .then(result => {
          if (result.data.ResultCode === 100) {
            this.$alertify.success(
              result.data.ReturnMessage
            )

            this.sessionData.splice(
              this.dockOutIndex,
              1
            )
          } else {
            this.$alertify.error(
              result.data.ReturnMessage
            )
          }

          this.isLoadingSearch = false
        })
        .catch(error => {
          this.isLoadingSearch = false

          console.error(error)

          this.$alertify.error(
            'Error performing dock out.'
          )
        })
    },

    getDockOutReasons() {
      this.isLoadingSearch = true

      axios({
        method: 'GET',
        url:
          apiUrl.api_url_hubops +
          'dockmaster/dockReasons?type=dock_out_reasons',
        headers: {
          authorization: 'authkey xB84JJ89Hd25',
        },
      })
        .then(result => {
          if (result.data.ResultCode === 100) {
            this.reasonOptions =
              result.data.ResponseData.map(
                function (item) {
                  return {
                    text: item.reason,
                    value: item.id,
                  }
                }
              )
          } else {
            this.$alertify.error(
              result.data.ReturnMessage
            )
          }

          this.isLoadingSearch = false
        })
        .catch(error => {
          console.error(error)
          this.isLoadingSearch = false
        })
    },

    onReasonSelect(option, index) {
      this.$set(
        this.sessionData[index],
        'selectedReason',
        option
      )
    },
  },
}


// WEBPACK FOOTER //
// ./src/views/components/ManualDockOut/ManualDockOut.js